import { MutationHookOptions } from '@apollo/client'
import B2C_APPLY_CARPAY_VOUCHER from '@graphql/mutation/applyCarpayVoucher.mutation'
import { B2CApplyCarpayVoucherMutation, B2CApplyCarpayVoucherMutationVariables } from 'parkdepot-shared/gql/graphql'
import { useAuthenticatedMutation } from './useAuth'

const useApplyCarpayVoucher = (
    opts: MutationHookOptions<B2CApplyCarpayVoucherMutation, B2CApplyCarpayVoucherMutationVariables>
) => {
    return useAuthenticatedMutation({ mutation: B2C_APPLY_CARPAY_VOUCHER, ...opts })
}

export default useApplyCarpayVoucher
